import React, { memo } from 'react';
import PropTypes from 'prop-types';
import StatelessModal from "./StatelessModal";
import { useModalState } from "../../../Hooks";
var ReactBootstrapModal = function ReactBootstrapModal(_ref) {
  var children = _ref.children,
    Title = _ref.Title,
    Body = _ref.Body,
    Footer = _ref.Footer,
    backdrop = _ref.backdrop,
    loaded = _ref.loaded,
    customProps = _ref.customProps;
  var _useModalState = useModalState(),
    show = _useModalState.show,
    hideModal = _useModalState.hideModal,
    showModal = _useModalState.showModal;
  return /*#__PURE__*/React.createElement(StatelessModal, {
    show: show,
    hideModal: hideModal,
    Title: Title,
    Body: Body,
    Footer: Footer,
    backdrop: backdrop,
    loaded: loaded,
    customProps: customProps
  }, function () {
    return children({
      showModal: showModal
    });
  });
};
ReactBootstrapModal.defaultProps = {
  customProps: null,
  Footer: null,
  backdrop: true,
  loaded: true,
  children: function children() {}
};
ReactBootstrapModal.propTypes = {
  children: PropTypes.func,
  Title: PropTypes.elementType.isRequired,
  Body: PropTypes.elementType.isRequired,
  Footer: PropTypes.elementType,
  loaded: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  customProps: PropTypes.shape({
    size: PropTypes.string,
    bsSize: PropTypes.string
  })
};
export default /*#__PURE__*/memo(ReactBootstrapModal);